module.exports = __webpack_public_path__ + "img/brand.687a31ef.png";